import React from "react";
import { AUTHORIZATION_BOUNDARY, CORRECTION_DRAFT_LABEL, CORRECTION_INTRO } from "../copy/decisionReviewCopy";
import Dialog from "../ui/Dialog";
import { abbreviateSha } from "./reviewDisplay";

export default function CorrectionPlanPreview({ review, finding, onClose }) {
  const evidence = finding?.evidence?.[0];
  return (
    <Dialog title="Correction plan" onClose={onClose}>
      <p>
        <strong>{CORRECTION_DRAFT_LABEL}</strong>
      </p>
      <p>{CORRECTION_INTRO}</p>
      <p>{AUTHORIZATION_BOUNDARY}</p>
      <h3>Observed behavior</h3>
      <p>{finding?.explanation}</p>
      <h3>Desired outcome</h3>
      <p>{finding?.productImpact || "Describe the product behavior that should remain true."}</p>
      <h3>Context</h3>
      <p>{finding?.contextRefs?.join(", ") || review?.contextSnapshot?.warning || "No confirmed product context is attached."}</p>
      <h3>Affected files</h3>
      <p>{evidence?.path || "No file path was stored on this finding."}</p>
      <h3>Draft acceptance criteria</h3>
      <ul>
        <li>The pull request matches the desired outcome above.</li>
        <li>Empty, loading, and failure behavior stay explicit.</li>
      </ul>
      <h3>Required tests</h3>
      <p>Cover the changed behavior and one failure path.</p>
      <h3>Source</h3>
      <p>
        {review?.owner}/{review?.name} #{review?.pullNumber} at {abbreviateSha(review?.headSha)}
      </p>
      <h3>Known uncertainty</h3>
      <p>This finding is an unconfirmed observation. It is not product truth, and no coding agent has received this plan.</p>
      <button type="button" className="rr-button" onClick={onClose}>
        Close draft
      </button>
    </Dialog>
  );
}
